import React, { useState, useEffect } from "react";
import { url } from "../Constant/TextConstant";
import "./ReviewSection.css";
import { apiFetch } from "../utils/apiClient.js";

const ReviewSection = ({ storeMobile, productCode }) => {
  const [reviews, setReviews] = useState([]);
  const [ratingCounts, setRatingCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        setLoading(true);
        const response = await apiFetch(
          `${url.baseAPIUrl}/api/ShopkeeperLikeReviewAndCall/GetReviewByMobile?StoreMobile=${storeMobile}`
        );

        if (!response.ok) throw new Error("Failed to fetch reviews");

        const data = await response.json();
        const productReviews = data.filter(
          (review) => review.ProductCode === productCode
        );
        setReviews(productReviews);

        const counts = {};
        for (let i = 1; i <= 5; i++) {
          counts[i] = productReviews.filter((r) => r.Rating === i).length;
        }
        setRatingCounts(counts);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (storeMobile && productCode) {
      fetchReviews();
    }
  }, [storeMobile, productCode]);

  if (loading) {
    return (
      <div className="reviews-loading">
        <div className="reviews-loading-spinner"></div>
        <p>Loading reviews...</p>
      </div>
    );
  }

  if (error) {
    return <div className="reviews-error">Error loading reviews: {error}</div>;
  }

  if (reviews.length === 0) {
    return <div className="no-reviews">No reviews yet for this product</div>;
  }

  return (
    <div className="reviews-section">
      <h3>Customer Reviews</h3>

      {/* Rating Breakdown */}
      <div className="rating-breakdown">
        {[5, 4, 3, 2, 1].map((stars) => (
          <div key={stars} className="rating-row">
            <span>{stars} ★</span>
            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{
                  width: `${
                    ((ratingCounts[stars] || 0) / reviews.length) * 100
                  }%`,
                }}
              ></div>
            </div>
            <span>{ratingCounts[stars] || 0}</span>
          </div>
        ))}
      </div>

      {/* Reviews List */}
      <div className="reviews-list">
        {reviews.slice(0, 3).map((review, index) => {
          const hasImages = review.Image1 || review.Image2;

          return (
            <div key={`${review.ID}-${index}`} className="review-card">
              <div className="review-header">
                <span className="reviewer-name">
                  {review.Name || "Anonymous"}
                </span>
                <div className="review-rating">
                  {[...Array(5)].map((_, i) => (
                    <span key={i} className={i < review.rating ? "filled" : ""}>
                      ★
                    </span>
                  ))}
                </div>
              </div>

              {hasImages && (
                <div className="review-images">
                  {review.Image1 && (
                    <ReviewImage
                      imagePath={`${url.reviewImageStartingPath}/${review.Image1}`}
                      altText="Review image 1"
                    />
                  )}
                  {review.Image2 && (
                    <ReviewImage
                      imagePath={`${url.reviewImageStartingPath}/${review.Image2}`}
                      altText="Review image 2"
                    />
                  )}
                </div>
              )}

              <p className="review-text">{review.reviews}</p>
              <div className="review-footer">
                <span className="review-date">{review.date}</span>
                <div className="review-actions">
                  <button>Helpful</button>
                  <button>Not Helpful</button>
                </div>
              </div>
            </div>
          );
        })}

        {reviews.length > 3 && (
          <button className="view-all-reviews">
            View all {reviews.length} reviews
          </button>
        )}
      </div>
    </div>
  );
};

// Separate component for handling review images
const ReviewImage = ({ imagePath, altText }) => {
  const [imageError, setImageError] = useState(false);

  if (imageError) return null;

  return (
    <img
      src={imagePath}
      alt={altText}
      className="review-image"
      onError={() => {
        setImageError(true);
      }}
      // onLoad={() =>}
    />
  );
};

export default ReviewSection;
